import { Button, Text } from '@zillow/constellation';

type Props = {
  displayText?: string;
  disabled?: boolean;
};

export const BigDropzone = ({ displayText, disabled }: Props) => (
  <>
    <Text as="div" marginY="sm">
      {displayText ? displayText : 'Drag photos here'}
    </Text>
    <Button size="sm" data-testid="BigDropzone-SelectFromComputer" disabled={disabled}>
      Select from computer
    </Button>
  </>
);
